/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-11-28 17:02:22
 * @LastEditors: hongye
 * @LastEditTime: 2025-03-12 13:49:31
 */
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import routerBefore from './routerBefore'
import {
  dataCenter,
  dataReportCenter,
  expressManagement,
  orderManagement,
  clientManagement,
  handoverManagement,
  orderList,
  warehouseManagement,
  setting,
  returnWarehouse,
  systemSwitch
} from './route'
import { NameEnum, UrlEnum, UnionEnum } from '@/utils/enums/Route'
const Layout = () => import('@/layout/index.vue')
const Login = () => import('@/views/login/Index.vue')
const ForgetPwd = () => import('@/views/forgetPwd/Index.vue')
const AuditInterception = () => import('@/views/auditInterception/Index.vue')
const NotFound = () => import('@/views/notfound/Index.vue')
const NoAuth = () => import('@/views/noauth/Index.vue')
const routes: RouteRecordRaw[] = [
  {
    path: UrlEnum[UnionEnum.HOME],
    name: 'Layout',
    component: Layout,
    children: [
      {
        path: UrlEnum[UnionEnum.HOME],
        name: 'Home',
        redirect: UrlEnum[UnionEnum.DATADASHBOARD]
      },
      {
        path: UrlEnum[UnionEnum.NOTFOUND],
        name: 'NotFound',
        component: NotFound,
        meta: { title: NameEnum[UnionEnum.NOTFOUND], requiresAuth: false, keepAlive: true }
      },
      {
        path: UrlEnum[UnionEnum.NOAUTH],
        name: 'NoAuth',
        component: NoAuth,
        meta: { title: NameEnum[UnionEnum.NOAUTH], requiresAuth: false, keepAlive: true }
      },
      ...dataCenter,
      ...dataReportCenter,
      ...expressManagement,
      ...orderManagement,
      ...clientManagement,
      ...handoverManagement,
      ...warehouseManagement,
      ...orderList,
      ...setting,
      ...returnWarehouse,
      ...systemSwitch
    ]
  },
  {
    path: UrlEnum[UnionEnum.AUDITINTERCEPTION],
    name: 'AuditInterception',
    component: AuditInterception,
    meta: { title: NameEnum[UnionEnum.AUDITINTERCEPTION], requiresAuth: false, keepAlive: false }
  },
  {
    path: UrlEnum[UnionEnum.LOGIN],
    name: 'Login',
    component: Login,
    meta: { title: NameEnum[UnionEnum.LOGIN], requiresAuth: false, keepAlive: false }
  },
  {
    path: '/smsCode',
    name: 'SmsCode',
    component: () => import('@/views/login/SmsCode.vue'),
    meta: { title: '认证', requiresAuth: false, keepAlive: false }
  },
  {
    path: UrlEnum[UnionEnum.FORGETPWD],
    name: 'ForgetPwd',
    component: ForgetPwd,
    meta: { title: NameEnum[UnionEnum.FORGETPWD], requiresAuth: false, keepAlive: false }
  },
  {
    path: '/:w+',
    name: '*',
    redirect: UrlEnum[UnionEnum.NOTFOUND]
  }
]

const index = createRouter({
  history: createWebHistory(),
  routes
})

//路由导航
routerBefore(index)
export default index
